<p-card  header="{{title()}}">
  <ng-content></ng-content>
</p-card>
